import { ISettingsDataHandler } from '../../data-handlers/settings/ISettingsDataHandler'

export class SettingsRepository {
  handler: ISettingsDataHandler

  constructor(handler: ISettingsDataHandler) {
    this.handler = handler
  }

  async requestSettings(): Promise<{ storeName: string, refreshInterval: number }> {
    return this.handler.requestSettings()
  }
}
